import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './PolicyPages.css';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-container" data-aos="fade-up">
      <header className="policy-header" data-aos="fade-down">
        <h1>Terms and Conditions</h1>
        <p>Last updated: November 27, 2025</p>
      </header>
      
      <section className="policy-section" data-aos="fade-right">
        <h2>1. Introduction</h2>
        <p>Welcome to <strong>Label Aadvi</strong>! These Terms and Conditions ("Terms") govern your use of our website located at <a href="https://www.labelaadvi.com" target="_blank" rel="noopener noreferrer">www.labelaadvi.com</a> ("Service"). By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.</p>
      </section>

      <section className="policy-section" data-aos="fade-left">
        <h2>2. Accounts</h2>
        <p>When you create an account with us, you must provide us with information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.</p>
        <p>You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password. You agree not to disclose your password to any third party.</p>
      </section>

      <section className="policy-section" data-aos="fade-right">
        <h2>3. Orders, Payments, and Cancellations</h2>
        <p>By placing an order through our Service, you warrant that you are legally capable of entering into binding contracts. All orders are subject to availability and confirmation of the order price.</p>
        <p>We partner with <strong>Razorpay</strong> to provide a secure and seamless payment experience. We accept various forms of payment as supported by Razorpay, which will be listed at checkout. Payment must be completed before the dispatch of goods. For more details on cancellations and refunds, please see our <Link to="/cancellation-refunds">Cancellation & Refunds Policy</Link>.</p>
      </section>

      <section className="policy-section" data-aos="fade-left">
        <h2>4. Shipping and Delivery</h2>
        <p>We are committed to delivering your products in a timely and efficient manner. Standard delivery times are estimated between 5-7 business days within India. Shipping times are estimates and not guaranteed. We are not responsible for delays caused by the shipping carrier or destination customs clearance processes. Please review our <Link to="/shipping-policy">Shipping Policy</Link> for more detailed information.</p>
      </section>

      <section className="policy-section" data-aos="fade-right">
        <h2>5. Refunds and Returns</h2>
        <p>We offer a 7-day return policy for most items. If you are not satisfied with your purchase, you may request a return or exchange within 7 days of receiving your order. To be eligible for a return, your item must be unused, in the same condition that you received it, and in its original packaging.</p>
        <p>Once your return is received and inspected, we will notify you of the approval or rejection of your refund. If approved, your refund will be processed, and a credit will automatically be applied to your original method of payment within a certain number of days.</p>
        <p>Please note that some items may be non-returnable. For more detailed information, please contact our customer support.</p>
      </section>

      <section className="policy-section" data-aos="fade-left">
        <h2>6. Intellectual Property</h2>
        <p>The Service and its original content, features, and functionality are and will remain the exclusive property of Label Aadvi and its licensors. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Label Aadvi.</p>
      </section>

      <section className="policy-section" data-aos="fade-right">
        <h2>7. Limitation of Liability</h2>
        <p>In no event shall Label Aadvi, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.</p>
      </section>

      <section className="policy-section" data-aos="fade-left">
        <h2>8. Governing Law</h2>
        <p>These Terms shall be governed and construed in accordance with the laws of India, without regard to its conflict of law provisions.</p>
      </section>

      <section className="policy-section" data-aos="fade-right">
        <h2>9. Changes to Terms</h2>
        <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.</p>
      </section>

      <section className="policy-section" data-aos="fade-up">
        <h2>10. Contact Us</h2>
        <p>If you have any questions about these Terms, please <Link to="/contact">contact us</Link>.</p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
